"use client";
import { jsxs as p, Fragment as H, jsx as a } from "react/jsx-runtime";
import * as v from "react";
import z from "classnames";
import { debounce as O } from "./utils/helpers.js";
import { isRunningAcceptanceTest as P } from "./utils/platform.js";
import { useBoundingRect as _, useScreenSize as j, useTheme as M, useElementDimensions as y, useWindowSize as W, useIsomorphicLayoutEffect as G } from "./hooks.js";
import { getScrollableParentElement as X, addPassiveEventListener as E, removePassiveEventListener as b, hasScroll as q, getScrollDistanceToBottom as J } from "./utils/dom.js";
import { Portal as K } from "./portal.js";
import { vars as T } from "./skins/skin-contract.css-mistica.js";
import { container as Q, footer as U, withoutFooter as V, elevated as Y, fixedFooter as Z, portal as C, fixedBackgroundLayer as ee, absoluteBackgroundLayer as S, vars as te } from "./fixed-footer-layout.css-mistica.js";
import { applyCssVars as oe, safeAreaInsetBottom as re } from "./utils/css.js";
import { useFixedToTopHeight as se } from "./fixed-to-top.js";
import { useOverScrollColor as ae } from "./overscroll-color-context.js";
const ie = (e)=>e === document.documentElement ? window : e, ne = (e)=>{
    const l = setTimeout(e, 0);
    return {
        cancel: ()=>clearTimeout(l)
    };
}, ce = 200, le = (param)=>{
    let { isFooterVisible: e = !0, footer: l, footerHeight: k = "auto", footerBgColor: i = T.colors.background, containerBgColor: F = T.colors.background, children: L, onChangeFooterHeight: n } = param;
    const [$, g] = v.useState(!1), d = v.useRef(null), { height: m } = _(d) || {
        height: 0
    }, { isTabletOrSmaller: u } = j(), { platformOverrides: h } = M(), { height: r, ref: w } = y({
        includeMargins: !0
    }), { visualHeight: D } = W(), s = se(), t = D - s - r > ce, { topColor: I = i } = ae(), { height: x, ref: N } = y();
    G(()=>{
        n == null || n(r);
    }, [
        n,
        r
    ]), v.useEffect(()=>{
        if (!u || P(h) || !t) {
            g(!1);
            return;
        }
        const f = X(d.current), A = ()=>q(f) && J(f) > s + 1, o = O(()=>{
            g(A());
        }, 50, {
            leading: !0,
            maxWait: 100
        }), B = ne(o), c = ie(f);
        return E(c, "resize", o), E(c, "scroll", o), ()=>{
            o.cancel(), b(c, "scroll", o), b(c, "resize", o), B.cancel();
        };
    }, [
        h,
        u,
        t,
        // `topDistance` and `contentHeight` dependencies are needed to recalculate the elevation state
        s,
        m
    ]);
    const R = ()=>/* @__PURE__ */ p(K, {
            className: C,
            children: [
                /* @__PURE__ */ a("div", {
                    className: ee,
                    style: {
                        background: `linear-gradient(180deg, ${I} 50%, ${i} 50% 100%)`
                    }
                }),
                /* @__PURE__ */ a("div", {
                    ref: N,
                    className: S,
                    style: {
                        background: F,
                        // this color could be a gradient
                        top: s - 1,
                        // -1 because the navigationbar could have a 1px transparent background
                        bottom: t ? r : "unset",
                        height: t ? "unset" : m
                    }
                }),
                /* @__PURE__ */ a("div", {
                    className: S,
                    style: {
                        background: i,
                        top: x + s - 1,
                        height: `calc(${m}px - ${x}px)`
                    }
                })
            ]
        });
    return /* @__PURE__ */ p(H, {
        children: [
            /* @__PURE__ */ p("div", {
                ref: d,
                className: Q,
                style: oe({
                    [te.footerHeight]: t ? `${r}px` : "0px"
                }),
                children: [
                    R(),
                    L
                ]
            }),
            /* @__PURE__ */ a("div", {
                className: z(U, {
                    [V]: !e,
                    [Y]: $,
                    [Z]: t
                }),
                style: {
                    background: u ? i : void 0
                },
                "data-testid": `fixed-footer${e ? "-visible" : "-hidden"}`,
                "data-position-fixed": "bottom",
                children: e && /* @__PURE__ */ a("aside", {
                    ref: w,
                    "data-component-name": "FixedFooter",
                    style: {
                        height: k,
                        marginBottom: re
                    },
                    children: l
                })
            })
        ]
    });
}, Se = le;
export { Se as default };
